// LoadingView.tsx
import React from 'react';

// 将来的に props を追加する場合は、以下のように型を定義
// interface LoadingViewProps {
//   message?: string;
// }

const LoadingView = () => ( // props がないため、() => ... で十分です。
  <div className="flex justify-center items-center h-screen bg-sky-50">
    <div className="animate-spin rounded-full h-20 w-20 border-t-4 border-b-4 border-cyan-500"></div>
    <p className="ml-4 text-xl text-cyan-700 font-bold">読み込み中...</p>
  </div>
);

export default LoadingView;